<template>
  <el-dialog
    :append-to-body="true"
    :close-on-click-modal="false"
    :before-close="cancel"
    :visible.sync="dialog"
    :title="isAdd ? '新增' : '编辑'"
    width="500px"
  >
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      size="small"
      label-width="80px"
    >
      <el-form-item
        label="种类"
        prop="speciesId"
        :rules="[{ required: true, message: '种类不能为空' }]"
      >
        <el-select
          v-model="form.speciesId"
          placeholder="请选择"
          style="width: 370px"
        >
          <el-option
            v-for="item in options1"
            :key="item.id"
            :label="item.speciesName"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="科目"
        prop="subjectId"
        :rules="[{ required: true, message: '科目不能为空' }]"
      >
        <el-select
          v-model="form.subjectId"
          placeholder="请选择"
          style="width: 370px"
        >
          <el-option
            v-for="item in options3"
            :key="item.subjectId"
            :label="item.subjectName"
            :value="item.subjectId"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="问题">
        <el-input
          v-model="form.issue"
          type="textarea"
          autosize
          style="width: 370px"
        />
      </el-form-item>
      <el-form-item label="话题" prop="topicId">
        <el-select
          v-model="form.topicId"
          placeholder="请选择"
          style="width: 370px"
        >
          <el-option
            v-for="item in options2"
            :key="item.id"
            :label="item.topicName"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="step1答案">
        <el-input
          v-model="form.step1Result"
          type="textarea"
          autosize
          style="width: 370px"
        />
      </el-form-item>
      <el-form-item label="step1音频">
        <el-link
          v-if="form.step1Music"
          target="_blank"
          :href="form.step1Music"
          style="width: 370px; margin-bottom: 10px"
          type="primary"
          >{{ form.step1Music }}</el-link
        >
        <el-upload
          class="upload-demo"
          action="https://jsonplaceholder.typicode.com/posts/"
          :on-change="handlePreview1"
          :auto-upload="false"
          accept=".mp3, .MP3, .mp4, .MP4"
          :file-list="fileList1"
        >
          <el-button
            :disabled="audio1"
            :loading="audio1"
            icon="el-icon-upload2"
            size="small"
            :type="buttonType1"
            style="width: 370px"
            >{{ audioText1 }}</el-button
          >
        </el-upload>
      </el-form-item>
      <el-form-item label="step2答案">
        <el-input
          v-model="form.step2Result"
          type="textarea"
          autosize
          style="width: 370px"
        />
      </el-form-item>
      <el-form-item label="step2音频">
        <el-link
          v-if="form.step2Music"
          target="_blank"
          :href="form.step2Music"
          style="width: 370px; margin-bottom: 10px"
          type="primary"
          >{{ form.step2Music }}</el-link
        >
        <el-upload
          class="upload-demo"
          action="https://jsonplaceholder.typicode.com/posts/"
          :on-change="handlePreview2"
          :auto-upload="false"
          accept=".mp3, .MP3, .mp4, .MP4"
          :file-list="fileList2"
        >
          <el-button
            :disabled="audio2"
            :loading="audio2"
            icon="el-icon-upload2"
            size="small"
            :type="buttonType2"
            style="width: 370px"
            >{{ audioText2 }}</el-button
          >
        </el-upload>
      </el-form-item>
      <el-form-item label="step3答案">
        <el-input
          v-model="form.step3Result"
          type="textarea"
          autosize
          style="width: 370px"
        />
      </el-form-item>
      <el-form-item label="step3音频">
        <el-link
          v-if="form.step3Music"
          target="_blank"
          :href="form.step3Music"
          style="width: 370px; margin-bottom: 10px"
          type="primary"
          >{{ form.step3Music }}</el-link
        >
        <el-upload
          class="upload-demo"
          action="https://jsonplaceholder.typicode.com/posts/"
          :on-change="handlePreview3"
          :auto-upload="false"
          accept=".mp3, .MP3, .mp4, .MP4"
          :file-list="fileList3"
        >
          <el-button
            :disabled="audio3"
            :loading="audio3"
            icon="el-icon-upload2"
            size="small"
            :type="buttonType3"
            style="width: 370px"
            >{{ audioText3 }}</el-button
          >
        </el-upload>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="text" @click="cancel">取消</el-button>
      <el-button :loading="loading" type="primary" @click="doSubmit"
        >确认</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { add, edit } from "@/api/specifictraining";
import OSS from "ali-oss";
import { getUUID } from "@/utils/uuid";
import { postTable, putTable } from "@/api/table";
export default {
  props: {
    isAdd: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      fileList1: [],
      buttonType1: "primary",
      audio1: false,
      audioText1: "点击上传",

      fileList2: [],
      buttonType2: "primary",
      audio2: false,
      audioText2: "点击上传",

      fileList3: [],
      buttonType3: "primary",
      audio3: false,
      audioText3: "点击上传",

      tableIndex: null, //表格

      loading: false,
      dialog: false,
      form: {
        // 种类id
        speciesId: null,
        // 种类名称
        speciesName: "",
        // 科目名称
        subjectId: "",
        // 问题
        issue: "",
        // step1答案
        step1Result: "",
        // step1音频
        step1Music: "",
        // step2答案
        step2Result: "",
        // step2音频
        step2Music: "",
        // step3答案
        step3Result: "",
        // step3音频
        step3Music: "",
        // 话题
        topicId: null,
      },
      options1: [],
      options2: [],
      options3: [],
      rules: {},
    };
  },
  methods: {
    cancel() {
      this.resetForm();
    },
    doSubmit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.loading = true;
          if (this.isAdd) {
            this.doAdd();
          } else this.doEdit();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    doAdd() {
      postTable(this.tableIndex, this.form).then((res) => {
        this.resetForm();
        this.$notify({
          title: "添加成功",
          type: "success",
          duration: 2500,
        });
        this.loading = false;
        this.$parent.tableUpdate();
      });
    },
    doEdit() {
      putTable(this.tableIndex, this.form).then((res) => {
        this.resetForm();
        this.$notify({
          title: "修改成功",
          type: "success",
          duration: 2500,
        });
        this.loading = false;
        this.$parent.init();
      });
    },
    resetForm() {
      this.dialog = false;
      this.$refs["form"].resetFields();
      this.form = {
        // 种类id
        speciesId: null,
        // 科目名称
        subjectName: "",
        // 问题
        issue: "",
        // step1答案
        step1Result: "",
        // step1音频
        step1Music: "",
        // step2答案
        step2Result: "",
        // step2音频
        step2Music: "",
        // step3答案
        step3Result: "",
        // step3音频
        step3Music: "",
        // 话题
        topicId: null,
      };
      this.fileList1 = [];
      this.buttonType1 = "primary";
      this.audio1 = false;
      this.audioText1 = "点击上传";

      this.fileList2 = [];
      this.buttonType2 = "primary";
      this.audio2 = false;
      this.audioText2 = "点击上传";

      this.fileList3 = [];
      this.buttonType3 = "primary";
      this.audio3 = false;
      this.audioText3 = "点击上传";
    },

    handlePreview1(e) {
      this.fileList1 = [];
      this.fileList1.push({ name: e.name });
      this.ossAudioPut(e.raw, e.size, 1);
    },
    handlePreview2(e) {
      this.fileList2 = [];
      this.fileList2.push({ name: e.name });
      this.ossAudioPut(e.raw, e.size, 2);
    },
    handlePreview3(e) {
      this.fileList3 = [];
      this.fileList3.push({ name: e.name });
      this.ossAudioPut(e.raw, e.size, 3);
    },

    async ossAudioPut(file, name, index) {
      let client = new OSS({
        region: "oss-cn-qingdao",
        accessKeyId: "LTAI4FnwTeoAmdGYHhJhZVTb",
        accessKeySecret: "pllurUCqkw5O4XxETNXnQg12mC5vQS",
        bucket: "jingjingliuxue",
      });
      this.audio = true;
      this.audioText = "正在拼命加载";
      this.loading = true;
      try {
        await client
          .put(`specialTraining/${getUUID()}${name}`, file)
          .then((e) => {
            if (index === 1) {
              this.form.step1Music = e.url;
              this.audio1 = false;
              this.audioText1 = "已加载完毕, (点击重新选择)";
              this.buttonType1 = "success";
            } else if (index === 2) {
              this.form.step2Music = e.url;
              this.audio2 = false;
              this.audioText2 = "已加载完毕, (点击重新选择)";
              this.buttonType2 = "success";
            } else if (index === 3) {
              this.form.step3Music = e.url;
              this.audio3 = false;
              this.audioText3 = "已加载完毕, (点击重新选择)";
              this.buttonType3 = "success";
            }
            this.loading = false;
            this.$message({
              message: "音频加载完毕",
              type: "success",
            });
          });
      } catch (e) {
        console.log(e);
        this.audio1 = false;
        this.audio2 = false;
        this.audio3 = false;
        this.loading = false;
        this.$message({
          message: "音频加载失败",
          type: "warning",
        });
      }
    },
  },
};
</script>

<style scoped>
</style>
